(function (window, INFORMA, $, undefined) {
  INFORMA.Shimmer = (function () {
    function SHIMMER() {
      var shimmerElement,
        objectContainer,
        shimmerStartTime = null,
        currentMinDisplayTime = 5000; // Default 5 seconds minimum display time

      this.Hide = function () {
        // Find shimmer cards on the page
        var allShimmers = $(".shimmer-card");

        if (allShimmers.length > 0) {
          var currentTime = new Date().getTime();
          var elapsedTime = shimmerStartTime
            ? currentTime - shimmerStartTime
            : currentMinDisplayTime;
          var remainingTime = Math.max(0, currentMinDisplayTime - elapsedTime);

          // If shimmer has been visible for less than 5 seconds, delay hiding
          setTimeout(function () {
            // Use CSS transition for compatibility with minimal Zepto
            allShimmers.css({
              opacity: "0",
              transition: "opacity 0.4s ease-out",
            });

            // Remove after transition completes
            setTimeout(function () {
              allShimmers.remove();
            }, 400);

            shimmerStartTime = null; // Reset start time
            objectContainer = null; // Clear container reference
          }, remainingTime);
        }
      };

      this.Show = function (container, options) {
        objectContainer = container;

        // Clean up any orphaned shimmers first
        var orphanedShimmers = $(".shimmer-card");
        if (orphanedShimmers.length > 0) {
          orphanedShimmers.remove();
        }

        var IsShimmerExist = objectContainer.find(".shimmer-card");

        // Default options
        var settings = $.extend(
          {
            rows: 3,
            type: "card", // 'card', 'list', 'text'
            minDisplayTime: 5000, // Default 5 seconds, can be overridden
          },
          options
        );

        // Set the minimum display time from options
        currentMinDisplayTime = settings.minDisplayTime;

        if (!IsShimmerExist.length) {
          var shimmerHTML = generateShimmerHTML(settings);
          // Create shimmer cards directly without wrapper
          shimmerElement = $(shimmerHTML);

          // Insert shimmer INSIDE the container to overlay content
          if (objectContainer.length > 0) {
            shimmerElement.prependTo(objectContainer);
          } else {
            shimmerElement.prependTo($("body"));
          }

          shimmerElement.show("fast");
          shimmerStartTime = new Date().getTime(); // Record when shimmer was shown
        } else {
          shimmerElement = IsShimmerExist;
          shimmerElement.show("fast");
          shimmerStartTime = new Date().getTime(); // Record when shimmer was shown
        }
      };

      var generateShimmerHTML = function (settings) {
        var html = "";

        switch (settings.type) {
          case "card":
            for (var i = 0; i < settings.rows; i++) {
              html +=
                '<div class="shimmer-card">' +
                '<div class="shimmer-image"></div>' +
                '<div class="shimmer-content">' +
                '<div class="shimmer-title"></div>' +
                '<div class="shimmer-line"></div>' +
                '<div class="shimmer-line short"></div>' +
                "</div>" +
                "</div>";
            }
            break;

          case "list":
            for (var i = 0; i < settings.rows; i++) {
              html +=
                '<div class="shimmer-list-item">' +
                '<div class="shimmer-circle"></div>' +
                '<div class="shimmer-list-content">' +
                '<div class="shimmer-line"></div>' +
                '<div class="shimmer-line short"></div>' +
                "</div>" +
                "</div>";
            }
            break;

          case "text":
          default:
            for (var i = 0; i < settings.rows; i++) {
              html +=
                '<div class="shimmer-text-block">' +
                '<div class="shimmer-line"></div>' +
                '<div class="shimmer-line"></div>' +
                '<div class="shimmer-line short"></div>' +
                "</div>";
            }
            break;
        }

        return html;
      };
    }

    return new SHIMMER();
  })();
})(window, (window.INFORMA = window.INFORMA || {}), $);
